'use strict';

exports.__esModule = true;
exports.RenderAsTagComponent = undefined;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var RenderAsTagComponent = function RenderAsTagComponent(_ref) {
	var _ref$as = _ref.as,
	    Tag = _ref$as === undefined ? 'div' : _ref$as,
	    props = _objectWithoutProperties(_ref, ['as']);

	return _react2.default.createElement(Tag, props);
};

exports.RenderAsTagComponent = RenderAsTagComponent;
RenderAsTagComponent.propTypes = {
	as: _propTypes.string
};

var Base = ( /*#__PURE__*/0, _styledBase2.default)(RenderAsTagComponent, {
	target: 'e1n4b2jv0',
	label: 'Base'
})('font-family:', function (_ref2) {
	var theme = _ref2.theme;
	return theme.typography.fontFamily;
}, ';font-size:', function (_ref3) {
	var theme = _ref3.theme;
	return theme.typography.fontSize;
}, ';color:', function (_ref4) {
	var theme = _ref4.theme;
	return theme.colors.textColor;
}, ';width:100%;input,button,textarea,select{font-family:', function (_ref5) {
	var theme = _ref5.theme;
	return theme.typography.fontFamily;
}, ';}*,*:before,*:after{box-sizing:border-box;}' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvQmFzZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVeUMiLCJmaWxlIjoiLi4vLi4vc3JjL3N0eWxlcy9CYXNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgUmVuZGVyQXNUYWdDb21wb25lbnQgPSAoeyBhczogVGFnID0gJ2RpdicsIC4uLnByb3BzIH0pID0+IDxUYWcgey4uLnByb3BzfSAvPjtcblxuUmVuZGVyQXNUYWdDb21wb25lbnQucHJvcFR5cGVzID0ge1xuXHRhczogc3RyaW5nLFxufTtcblxuY29uc3QgQmFzZSA9IHN0eWxlZChSZW5kZXJBc1RhZ0NvbXBvbmVudClgXG5cdGZvbnQtZmFtaWx5OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnR5cG9ncmFwaHkuZm9udEZhbWlseX07XG5cdGZvbnQtc2l6ZTogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50eXBvZ3JhcGh5LmZvbnRTaXplfTtcblx0Y29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzLnRleHRDb2xvcn07XG5cdHdpZHRoOiAxMDAlO1xuXG5cdGlucHV0LFxuXHRidXR0b24sXG5cdHRleHRhcmVhLFxuXHRzZWxlY3Qge1xuXHRcdGZvbnQtZmFtaWx5OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnR5cG9ncmFwaHkuZm9udEZhbWlseX07XG5cdH1cblxuXHQqLFxuXHQqOmJlZm9yZSxcblx0KjphZnRlciB7XG5cdFx0Ym94LXNpemluZzogYm9yZGVyLWJveDtcblx0fVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgQmFzZTtcbiJdfQ== */'));

exports.default = Base;